module.exports = __webpack_public_path__ + "static/media/mobileAddMobileWalletIcon.43581d48.svg";